import type { Fetcher } from 'swr';
import useSWR from 'swr';

import { fetchInvoicesFilter } from '~/data/hooks/fetchInvoicesFilter';
import {
  API_InvoiceFilterResponse,
  API_InvoiceFilterSearchParamsInput,
} from '~/data/schemas/invoice';

const invoiceFilterFetcher: Fetcher<
  API_InvoiceFilterResponse,
  readonly ['invoice', UseInvoicesParameters]
> = async ([_, params]) => {
  return fetchInvoicesFilter(params ?? {});
};

export type UseInvoicesParameters = API_InvoiceFilterSearchParamsInput | undefined;
export type UseInvoicesHook = {
  invoices: API_InvoiceFilterResponse['results'] | undefined;
  metadata: API_InvoiceFilterResponse['metadata'] | undefined;
  isLoading: boolean;
  error: unknown;
};

/**
 * Returns all Invoices the authenticated user has access to.
 */
export default function useInvoices(
  options: UseInvoicesParameters = {},
  enabled = true,
): UseInvoicesHook {
  const { data, error, isLoading } = useSWR(
    enabled ? (['invoice', options] as const) : null,
    invoiceFilterFetcher,
    // This is needed to prevent MUI datagrid from resetting the pagination model when the data changes
    // This is caused because the numRows resets to 0 when the data changes
    // See https://mui.com/x/react-data-grid/pagination/#index-based-pagination
    { keepPreviousData: true },
  );

  return {
    invoices: data?.results,
    metadata: data?.metadata,
    isLoading: isLoading,
    error,
  };
}
